import { useContext } from 'react';

import { AuthContext } from './AuthContext';
import { RoleRank, type AuthContextValue, type Role } from './types';

export function useAuth(): AuthContextValue {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used inside <AuthProvider>');
  return ctx;
}

export function useHasRole(required: Role): boolean {
  const { user } = useAuth();
  if (!user) return false;
  return RoleRank[user.role] >= RoleRank[required];
}
